import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const OnlineStatus = props => {
  const { status, className = 'Offline', ...rest } = props;

  return (
    <div className={classNames('online-status', className)} {...rest}>
      {status === 'Offline' ? (
        <i className="zmdi zmdi-circle-o Offline" title="Offline" />
      ) : (
        <i className={`zmdi zmdi-circle ${status}`} title={status} />
      )}
    </div>
  );
};

OnlineStatus.propTypes = {
  status: PropTypes.oneOf(['Available', 'Offline', 'Busy', 'Away']),
  className: PropTypes.string,
};

export default OnlineStatus;
